import React from 'react';
import './style/Footer.css';


const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>MOE Shop</p>
                <p className="signa">Новиков Е.Е.</p>
            </div>
        </footer>
    );
};

export default Footer;
